<div id="showStationDataContainer" [@.disabled]="applicationSettings?.option?.disableSlideInAnimation ?? false">
  <!-- Navigation bar for the station view -->
  <div id="navBar">
    @if (!inLayerPicker) {
    <div class="goBackButtonWrapper">
      @if (activeLayer !== null && !stationSettings[activeLayer]?.directToFeature) {
      <div (click)="goBackToPickers()" id="goBackButton" matTooltip={{selText.goBack}} matTooltipClass="tooltipStyle">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="20px" height="20px">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
          </svg>
          </div>
          }
          </div>
    }

    @if (inLayerPicker) {
    <div class="chooseLayerWrapper">
      <h6>
        {{selText.stationPickLayer}}:
      </h6>
    </div>
    }

    @if (inFeaturesPicker && !isPlaneLayerActive) {
    <div class="moreInfoHeaderWrapper">
      <h6 class="moreInfoHeader">{{selText.chooseStationHelpText}}:</h6>
    </div>
    }

    @if (inFeaturesPicker === false && inLayerPicker === false && activeLayer !== null &&
    !stationSettings[activeLayer]?.disablePDF) {
    <div class="highlightIconWrapper">
      <mat-icon (click)="generatePDF()" id="pdfButton" class="drawFeatureIcon" matTooltipClass="tooltipStyle"
        matTooltip="{{selText.generatePDF}}">picture_as_pdf</mat-icon>
      </div>
    }

    @if (isInEditMode === false && inFeaturesPicker === false && inLayerPicker === false && activeLayer !== null &&
    applicationSettings?.option?.featureOnHover?.draw === false) {
    <div class="highlightIconWrapper">
      <mat-icon (click)="displayFeature(activeLayer, 'click')" class="drawFeatureIcon" matTooltipClass="tooltipStyle"
        matTooltip="{{selText.drawFeature}}">location_on</mat-icon>
    </div>
    }

    @if (isUserLoggedIn && !isInEditMode && !inFeaturesPicker && !inLayerPicker && isEditOptionAvailable &&
    (userAccess >= UserAccess.Update || !userConfigAccess)) {
    <div class="highlightIconWrapper">
      <mat-icon *ngIf="publishColumn && creatorColumn
          && stationDataFeature?.geoJSONFeature?.features?.[0]?.properties?.[publishColumn] === -2
          && userAccess < UserAccess.Admin
          && loginName !== stationDataFeature?.geoJSONFeature?.features?.[0]?.properties?.[creatorColumn];
          else editIcon" class="drawFeatureIcon disabledIcon" matTooltipClass="tooltipStyle"
        [matTooltip]="selText.editRecordLocked">
        locked
      </mat-icon>
      <ng-template #editIcon>
      <ng-container *ngIf="editOptions?.length; else normalEditIcon">
        <button mat-icon-button [matMenuTriggerFor]="editMenu" class="drawFeatureIcon" matTooltipClass="tooltipStyle"
          [matTooltip]="selText.editRecord">
          <mat-icon>edit</mat-icon>
        </button>
        <mat-menu #editMenu="matMenu">
          <button mat-menu-item *ngFor="let option of editOptions" (click)="onEditOptionSelected(option)">
            {{ option.description }}
          </button>
        </mat-menu>
      </ng-container>
      <ng-template #normalEditIcon>
          <mat-icon (click)="goToEditFeature()" class="drawFeatureIcon" matTooltipClass="tooltipStyle"
            [matTooltip]="selText.editRecord">
            edit
          </mat-icon>
        </ng-template>
      </ng-template>
    </div>
    }

    <button class="closeButton closeBtn highlightIconWrapper" (click)="closeView();">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (inLayerPicker === true) {
  <div>
    @if (layersAvailableToPick.length > 0) {
    <div [@slideIn]>
      @for (layer of layersAvailableToPick; track layer) {
      <div class="chooseStationRow singleRowWithArrow" (click)="layerPicked(layer.id)"
        [@.disabled]="slideInAnimationDisabled[layer.id]">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="15px" height="15px" id="featureArrow">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
        </svg>
        <p>{{layer.header}}</p>
      </div>
      }
      </div>
      }
      </div>
  }

  @if (inFeaturesPicker === true) {
  @if (inFeaturesPicker === true && isPlaneLayerActive === true) {
  <div id="inputContainer">
    <h6 class="moreInfoHeader">{{selText.settings}}:</h6>
    <div id="input">
      <mat-form-field appearance="fill">
        <mat-label>{{selText.pickDatum}}</mat-label>
        <mat-select [(value)]="selectedDatum">
          @for (option of currentDatumOptions; track option) {
          <mat-option [value]="option">{{option}}</mat-option>
          }
        </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>{{selText.pickCoordsFormat}}</mat-label>
        <mat-select [(value)]="selectedCoordsFormat">
          <mat-option value="Lat/Long">Lat/Long</mat-option>
          <mat-option value="LCC">LCC</mat-option>
          <mat-option value="Cartesian">X, Y, Z</mat-option>
        </mat-select>
        </mat-form-field>
        </div>
        </div>
        }
        @if (featuresToChoose.length > 0 && activeLayer !== null) {
  <div [@slideIn] [@.disabled]="slideInAnimationDisabled[activeLayer]">
    <!-- ngIf here ensures that the animation is always run when new data comes in(Beacause it destroys&recreates the elements)-->
    @for (feat of featuresToChoose; track feat) {
    <div class="chooseStationRow singleRowWithArrow" (click)="stationPicked(feat.id, $event);">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="15px" height="15px" id="featureArrow">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
      </svg>
      <p>{{feat.value}}</p>
    </div>
    }
    </div>
    }
  }

  @if (inFeaturesPicker === false && inLayerPicker === false) {
  <div [@.disabled]="slideInAnimationDisabled[activeLayer ?? '0']">
    <div style="z-index: 2;" [@slideIn]>
      @for (singleRow of activeStation; track singleRow) {
      @if (singleRow.hide !== true) {
      <div class="singleRow" [ngClass]="{'warning': singleRow.noDatumRow === true}"
        [ngStyle]="{'justify-content':singleRow?.section !== undefined ? 'center' : ''}">
        <p class="header">{{singleRow.header}}</p>
        <app-content-decider class="value" [content]="singleRow.value" [selText]="selText"
          [layerID]="activeLayer?.toString() ?? ''"
          [key]="singleRow.key" [lang]="lang"></app-content-decider>
      </div>
      }
      }
    </div>
    </div>
  }
</div>
<div #loadingLogoContainer class="loadingLogoContainer"></div>